export default "__VITE_ASSET__DSQPYxAv__"